import { Component } from '@angular/core';

@Component({
    selector: 'create-experience',
    templateUrl: 'create-experience.component.html',
    styleUrls: ['create-experience.component.scss']
})
export class CreateExperienceComponent {

}
